import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@ngneat/transloco';
import { zZdravotniPojistovnaAStav2026, ZdravotniPojistovnaAStav } from '../utils';

@Pipe({
  name: 'healthDisadvantage',
})
export class HealthDisadvantagePipe implements PipeTransform {
  transform(value: string, ...args: any[]): any {
    let returnedText;
    if (typeof value === 'string') {
      switch (value) {
        case 'no': {
          returnedText = translate('TPA.No');
          break;
        }
        case 'ozz': {
          returnedText = translate('TPA.Ozz');
          break;
        }
        // firstorseconddegreeinvalidity is deprecated since 2026 (only for 2024)
        case 'firstorseconddegreeinvalidity': {
          returnedText = translate('TPA.InvalidityOneTwo');
          break;
        }
        case 'firstdegreeinvalidity': {
          returnedText = translate('TPA.InvalidityOne');
          break;
        }
        case 'seconddegreeinvalidity': {
          returnedText = translate('TPA.InvalidityTwo');
          break;
        }
        case 'thirddegreeinvalidity': {
          returnedText = translate('TPA.InvalidityThree');
          break;
        }
        default: {
          returnedText = value;
        }
      }
    }
    else {
      // ztpp: z.boolean().nullish(),
      // a1: z.boolean().nullish(),

      // invaliditaPrvnihoStupne: z.boolean().optional().nullable(),
      // invaliditaDruhehoStupne: z.boolean().optional().nullable(),

    }
    return returnedText;
  }
}
